"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const EXPIRATION_COOKIE_TIME = 4 / 48; // 2 Horas
class Interceptor {
    constructor(settings) {
        var _a, _b, _c;
        this.disableBearer = false;
        this.disableBearer = (_a = settings.disableBearer) !== null && _a !== void 0 ? _a : false;
        this.authorizationCookieName = settings.authorizationCookieName;
        this.onRequestInterceptor = settings.onRequest;
        this.onResponseInterceptor = settings.onResponse;
        this.baseHeaders = (_b = settings.baseHeaders) !== null && _b !== void 0 ? _b : {};
        this.logoutURL = (_c = settings.logoutURL) !== null && _c !== void 0 ? _c : `https://login.${settings.env === 'development' ? 'qa.' : ''}locaweb.com.br/logout?service=${window.location.origin}`;
    }
    get onRequest() {
        return (config) => {
            var _a;
            const token = js_cookie_1.default.get(this.authorizationCookieName);
            if (config.headers) {
                if (token) {
                    config.headers.Authorization = `${this.disableBearer ? '' : 'Bearer '}${token}`;
                }
                Object.keys(this.baseHeaders).forEach((key) => {
                    // @ts-ignore
                    config.headers[key] = this.baseHeaders[key];
                });
            }
            (_a = this.onRequestInterceptor) === null || _a === void 0 ? void 0 : _a.call(this, config);
            return config;
        };
    }
    get onResponse() {
        return (response) => {
            var _a;
            if (response.headers.Authorization && this.authorizationCookieName) {
                let domain = window.location.hostname;
                domain = domain.startsWith('www.') ? domain.replace('www.', '') : domain;
                js_cookie_1.default.set(this.authorizationCookieName, response.headers.Authorization, {
                    domain: domain === 'localhost' ? domain : `.${domain}`,
                    expires: EXPIRATION_COOKIE_TIME,
                    sameSite: 'strict',
                    secure: true
                });
            }
            (_a = this.onRequestInterceptor) === null || _a === void 0 ? void 0 : _a.call(this, response);
            return response;
        };
    }
    get onResponseError() {
        return (error) => {
            if (error.response && error.response.status === 401 && this.authorizationCookieName) {
                js_cookie_1.default.remove(this.authorizationCookieName);
                window.open(this.logoutURL, '_self');
            }
            return Promise.reject(error);
        };
    }
}
exports.default = Interceptor;
